<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 25 24">
    <path d="M12.5,18.6L2.3,8.4l2.4-2.4,7.8,7.8,7.8-7.8,2.4,2.4-10.2,10.2Z" />
  </svg>
</template>
